import { createFileRoute, useParams, Link } from '@tanstack/react-router'
import { Loader2, ArrowLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useProjects } from '@/hooks/useProjects'
import { GscPage } from '@/components/gsc/GscPage'
import { PageHeader } from '@/components/shared/PageHeader'

export const Route = createFileRoute('/_authenticated/projekty/$projectId/gsc')({
  component: GscRoute,
})

function GscRoute() {
  const { projectId } = useParams({ from: '/_authenticated/projekty/$projectId/gsc' })
  const { data: projects, isLoading } = useProjects()
  const project = projects?.find((p) => p.id === projectId)

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="h-8 w-8 animate-spin" style={{ color: 'var(--text-muted)' }} />
      </div>
    )
  }

  if (!project) {
    return (
      <div className="space-y-4">
        <p style={{ color: 'var(--text-muted)' }}>Nie znaleziono projektu.</p>
        <Button variant="outline" asChild>
          <Link to="/projekty">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Wróć do projektów
          </Link>
        </Button>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <PageHeader
        title="Google Search Console"
        breadcrumbItems={[
          { label: 'Projekty', to: '/projekty' },
          { label: project.name, to: '/projekty/$projectId', params: { projectId } },
          { label: 'Google Search Console' },
        ]}
      />
      <GscPage projectId={projectId} />
    </div>
  )
}
